export const SITUACAO_MATRICULA = {
  // SITUACAO DE MATRICULA DO SISTEMA ESCOLAR

  0: "PENDENTE", // ---------------- ALUNO ESPERANDO MATRÍCULA SER RENOVADA NA 1º FASE DE MATRÍCULA
  1: "ATIVA", // ------------------- ALUNO ESTUDANDO
  2: "EM TRANSFERÊNCIA", // -------- ALUNO SOLICITOU TRANSFERÊNCIA E ESTÁ AGUARDANDO OUTRA ESCOLA CAPTURÁ-LO
  3: "FECHADA (OCULTADA)", // ------ MATRÍCULA FECHADA (NÃO APARECE NA LISTAGEM)
  4: "CONCLUÍDA", // --------------- ALUNO CONCLUIU O PERÍODO LETIVO EM QUESTÃO
  5: "CANCELADO", // --------------- MATRÍCULA CANCELADA POR MOTIVOS DE ERRO (APARECE NAS LISTAGENS)
  6: "INATIVO", // ----------------- MATRÍCULA INATIVADA NÃO APARECE NAS LISTAGENS
  7: "TRANSFERIDO", // ------------- QUANDO UMA NOVA MATRÍCULA É ATIVADA APÓS TRANSFERÊNCIA. A ANTERIOR FICA COM O STATUS TRANSFERIDO
  8: "RECLASSIFICADO", // ---------- ALUNO É MATRICULADO EM UMA CURSO DIFERENTE APÓS ANÁLISE E PERMISSÃO DA SMED
  9: "REALOCADO", // --------------- ALUNO É MATRICULADO EM UMA NOVA CURSO OU TURMA PARA CORREÇÃO NO SISTEMA
  10: "EVADIDO", // ---------------- ALUNO SE EVADIU ANTES DO TÉRMINO DO ANO LETIVO
  11: "DESISTENTE", //-------------- ALUNO DESISTIU ANTES DO TÉMINO DO ANO LETIVO
  12: "FECHADA", //----------------- MATRÍCULA FECHADA (APARECE NA LISTAGEM)
  13: "RENOVADA",
  14: "NÃO CONCLUÍDO",
  15: "AGENDADO",

  // 0: 'ATIVA', ------------------- SITUAÇÃO_MATRICULA: ATIVA
  // 1: 'CONCLUIDA', --------------- SITUAÇÃO_MATRICULA: CONCLUIDA + FECHADA
  // 2: 'TRANCADA', ---------------- REMOVIDA
  // 3: 'CANCELADO', --------------- SITUAÇÃO_MATRICULA: CANCELAD0
  // 4: 'PENDENTE', ---------------- SITUAÇÃO_MATRICULA: PENDENTE
  // 5: 'EM_TRANSFERENCIA', -------- SITUAÇÃO_MATRICULA: EM_TRANSFERÊNCIA
  // 6: 'TRANSFERIDO', ------------- SITUAÇÃO_MATRICULA: TRANSFERIDO
  // 7: 'EVADIDO', ----------------- SITUACAO_ACADEMICA: EVADIDO
  // 8: 'INATIVO', ----------------- SITUAÇÃO_MATRICULA: INATIVO
  // 9: 'DESISTENTE', -------------- SITUACAO_ACADEMICA: DESISTENTE
  // 10: 'RECLASSIFICACA', --------- SITUAÇÃO_MATRICULA: RECLASSIFICADA
  // 11: 'REALOCACAO', ------------- SITUAÇÃO_MATRICULA: REALOCACAO
  // 12: 'FALECIDO', --------------- SITUACAO_ACADEMICA: FALECIDO
  // 13: 'FECHADA' ----------------- REMOVIDA
};

export const SITUACAO_ACADEMICA = {
  // SITUAÇÃO ACADEMICA DO SISTEMA ESCOLAR

  0: "ABERTO", // ------------------ CURSANDO AINDA NÃO SE SABE SE O ALUNO FOI APROVADO, CONSERVADO ETC
  1: "APROVADO", // ---------------- ALUNO OBTEVE NOTA ACIMA DE MÉDIA ANUAL E FOI APROVADO
  2: "CONSERVADO", // -------------- ALUNO NÃO OBTEVE A MÉDIA ANUAL NECESSÁRIA PARA A SUA APROVAÇÃO
  3: "EVADIDO", //------------------ ALUNO PAROU DE FREQUENTAR A INSTITUIÇÃO E A INSTITUIÇÃO NÃO SABE O MOTIVO
  4: "DESISTENTE", // -------------- ALUNO PAROU DE FREQUENTAR A INSTITUIÇÃO E A INSTITUIÇÃO FOI COMUNICADA SOBRE O MOTIVO
  5: "FALECIDO", // ---------------- ALUNO FALECEU
  6: "TRANSFERIDO", // ------------- ALUNO SAIU DA INSTITUIÇÃO ANTES DO TÉRMINO
  7: "RECLASSIFICADO", // ---------- ALUNO FOI RECLASSIFICADO PARA OUTRA CURSO
};

export const TIPO_USER = {
  0: "SECRETÁRIO ESCOLAR",
  1: "DIRETOR ESCOLAR",
  2: "PROFESSOR",
  3: "COORDENADOR PEDAGÓGICO",
  4: "NTI - PMVC",
  5: "NTI - SMED",
  6: "SMED - LEGALIZAÇÃO",
  7: "SMED - PEDAGÓGICO",
  8: "SMED - RECURSOS HUMANOS",
  9: "SMED - TABULAÇÃO",
  10: "CONSULTA",
  11: "BUSCA ATIVA",
  12: "VICE-DIRETOR",
};

export const LOCALIZACAO_ZONA = {
  1: "URBANA",
  2: "RURAL",
};

export const SITUACAO_FUNCIONAMENTO = {
  1: "EM ATIVIDADE",
  2: "PARALISADA",
  3: "EXTINTA",
};

export const SEXO = {
  0: "MASCULINO",
  1: "FEMININO",
};

export const RACA_COR = {
  0: "NÃO DECLARADA",
  1: "BRANCA",
  2: "PRETA",
  3: "PARDA",
  4: "AMARELA",
  5: "INDÍGENA",
};

export const TURNO = {
  0: "MATUTINO",
  1: "VESPERTINO",
  2: "NOTURNO",
  4: "INTEGRAL", //O EDF PULOU O NÚMERO 3. A IMPORTAÇÃO MANTEVE A ORDEM.
};

export const SITUACAO_TURMA = {
  0: "CONCLUIDO",
  1: "ATIVO",
  2: "PENDENTE",
  3: "INATIVO",
};

export const TIPO_ENSINO = {
  1: "ENSINO REGULAR",
  2: "EJA",
  3: "EDUCAÇÃO ESPECIAL",
  4: "ATIVIDADE COMPLEMENTAR",
  5: "PROJOVEM",
};

export const CONTEXTO_FREQUENCIA = {
  "PRINCIPAL": "PRINCIPAL",
  "AEE": "AEE",
  "ATIVIDADE_COMPLEMENTAR": "ATIVIDADE_COMPLEMENTAR"
};

export const ETAPA = {
  0: "EDUCAÇÃO INFANTIL",
  1: "FUNDAMENTAL I",
  2: "FUNDAMENTAL II",
};

export const CURSO_NACIONAL = {
  1: "CRECHE 1 ANO",
  2: "CRECHE 2 ANOS",
  3: "CRECHE 3 ANOS",
  4: "EDUCAÇÃO INFANTIL - 04 ANOS",
  5: "EDUCAÇÃO INFANTIL - 05 ANOS",
  6: "1º ANO",
  7: "2º ANO",
  8: "3º ANO",
  9: "4º ANO",
  10: "5º ANO",
  11: "6º ANO",
  12: "7º ANO",
  13: "8º ANO",
  14: "9º ANO",
};

export const TIPO_SERVIDOR = {
  1: "DIRETOR",
  2: "COORDENADOR PEDAGÓGICO",
  3: "PROFESSOR",
};

export const CARGO_SERVIDOR = {
  1: "CARGO 1",
  2: "CARGO 2",
  3: "CARGO 3",
  4: "CARGO 4",
};

export const FUNCAO_SERVIDOR = {
  1: "DOCENTE",
  2: "AUXILIAR/ASSISTENTE EDUCACIONAL",
  3: "PROFISSIONAL/MONITOR DE ATIVIDADE  COMPLEMENTAR",
  4: "TRADUTOR E INTERPRETE DE LIBRAS",
  // 5: 'DOCENTE TITULAR - COORDENADOR DE TUTORIA (DE  MÓDULO OU DISCIPLINA) - EAD',
  // 6: 'DOCENTE TUTOR - AUXILIAR (DE MÓDULO OU DISCIPLINA) - EAD',
  7: "GUIA-INTERPRETE",
  8: "PROFISSIONAL DE APOIO ESCOLAR PARA ALUNO(A)S COM DEFICIENCIA (LEI 13.146/2015)",
  9: "SECRETARIO ESCOLAR",
  10: "AUXILIAR DE SECRETARIA",
  11: "DIRETOR",
  12: "VICE-DIRETOR",
  13: "COORDENADOR PEDAGÓGICO",
  14: "PEDAGOGO",
  15: "INSTRUTOR DE OFICINA",
};

export const SITUACAO_FUNCIONAL_SERVIDOR = {
  1: "CONCURSADO/EFETIVO/ESTAVEL",
  2: "CONTRATO TEMPORARIO",
  3: "CONTRATO TERCEIRIZADO",
  4: "CONTRATO CLT",
};

export const MAIOR_ESCOLARIDADE_SERVIDOR = {
  1: "NÃO CONCLUIU O ENSINO FUNDAMENTAL",
  2: "ENSINO FUNDAMENTAL",
  7: "ENSINO MÉDIO",
  6: "EDUCAÇÃO SUPERIOR",
};

export const TIPO_ENSINO_MEDIO_SERVIDOR = {
  1: "FORMAÇÃO GERAL",
  2: "MODALIDADE NORMAL (MAGISTÉRIO)",
  3: "CURSO TÉCNICO",
  4: "MAGISTÉRIO INDÍGENA - MODALIDADE NORMAL",
};

export const POS_GRADUACAO_SERVIDOR = {
  "1": "ESPECIALIZACAO",
  "2": "MESTRADO",
  "3": "DOUTORADO",
};

export const AREA_POS_GRADUACAO_SERVIDOR = {
  99: "PROGRAMAS BÁSICOS",
  1: "EDUCAÇÃO",
  2: "ARTES E HUMANIDADES",
  3: "CIÊNCIAS SOCIAIS, COMUNICAÇÃO E INFORMAÇÃO",
  4: "NEGÓCIOS, ADMINISTRAÇÃO E DIREITO",
  5: "CIÊNCIAS NATURAIS, MATEMÁTICA E ESTATÍSTICA",
  6: "COMPUTAÇÃO E TECNOLOGIAS DA INFORMAÇÃO E COMUNICAÇÃO (TIC)",
  7: "ENGENHARIA, PRODUÇÃO E CONSTRUÇÃO",
  8: "AGRICULTURA, SILVICULTURA, PESCA E VETERINÁRIA",
  9: "SAÚDE E BEM-ESTAR",
  10: "SERVIÇOS",
};

export const SALA_LOCAL_DIFERENCIADO = {
  0: "NÃO",
  1: "SALA ANEXA",
  2: "UNIDADE DE ATENDIMENTO SOCIOEDUCATIVO",
  3: "UNIDADE PRISIONAL",
};

export const HISTORICO_PENDENTE = {
  0: "FALTANDO",
  1: "CONFECCIONAR",
  2: "RECEBIDO",
  3: "ENTREGUE",
  4: "PRONTO P/ ENTREGA",
};

/****** CONSTANTES EDUCACENSO ******/

export const LOCALIZACAO_DIFERENCIADA_ESCOLA = {
  1: "ÁREA DE ASSENTAMENTO",
  2: "TERRA INDÍGENA",
  3: "COMUNIDADE QUILOMBOLA",
  7: "NÃO ESTÁ EM ÁREA DE LOCALIZAÇÃO DIFERENCIADA",
  8: "ÁREA ONDE SE LOCALIZAM POVOS E COMUNIDADES TRADICIONAIS",
};

export const DEPENDENCIA_ADMINISTRATIVA = {
  1: "FEDERAL",
  2: "ESTADUAL",
  3: "MUNICIPAL",
  4: "PRIVADA",
};

export const REGULAMENTACAO_AUTORIZACAO = {
  0: "NÃO",
  1: "SIM",
  2: "EM TRAMITAÇÃO",
};

export const FORMA_OCUPACAO_PREDIO = {
  1: "PRÓPRIO",
  2: "ALUGADO",
  3: "CEDIDO",
};

export const RELATORIO_ALUNO_AGRUPAMENTO = {
  instituicao: "Instituição",
  turma: "Turma",
  curso: "curso",
  bairro: "Bairro",
};

export const STATUS_PRE_MATRICULA = {
  1: "PROCESSANDO",
  2: "ATIVO",
  3: "CANCELADO",
  4: "FINALIZADO",
};

export const STATUS_SUPORTE = {
  1: "EM ABERTO",
  2: "EM ANÁLISE",
  3: "FINALIZADO",
};

export const STATUS_EDUCACENSO = {
  1: "PENDENTE",
  2: "ARQUIVO GERADO",
  4: "MIGRADO",
  5: "FECHADO",
};


export const NOME_MES = (ref) => {
  
  let data = ref.split("-")
  
  switch (data[0]) {
    case '01': return "JANEIRO - " + data[1];
    case '02': return "FEVEREIRO - " + data[1];
    case '03': return "MARÇO - " + data[1];
    case '04': return "ABRIL - " + data[1];
    case '05': return "MAIO - " + data[1];
    case '06': return "JUNHO - " + data[1];
    case '07': return "JULHO - " + data[1];
    case '08': return "AGOSTO - " + data[1];
    case '09': return "SETEMBRO - " + data[1];
    case '10': return "OUTUBRO - " + data[1];
    case '11': return "NOVEMBRO - " + data[1];
    case '12': return "DEZEMBRO - " + data[1];
    default:
      return ref;
  }

};

export const FASE_DIARIO = {
  1: "-",
  2: "CONSELHO PARCIAL",
  3: "CONSELHO PARCIAL ENCERRADO",
  4: "CONSELHO FINAL",
  5: "FECHADO",
};

export const DIARIO_ORDEM_DISCIPLINAS = [
  36, //LÍNGUA/LITERATURA PORTUGUESA
  33, //MATEMÁTICA
  35, //CIÊNCIAS
  42, //HISTÓRIA
  43, //GEOGRAFIA
  37, //LÍNGUA/LITERATURA ESTRANGEIRA – INGLÊS
  41, //EDUCAÇÃO FÍSICA
  40, //ARTE (EDUCAÇÃO ARTÍSTICA, TEATRO, DANÇA, MÚSICA, ARTES PLÁSTICAS E OUTRAS)
  49, //ENSINO RELIGIOSO
  6,  //HISTÓRIA E CULTURA AFRO
  14, //EDUCACAO AMBIENTAL
  7   //TECNICAS AGRICOLAS
];

export const DIARIO_DISCIPLINAS_NAO_REPROVAM = [
  49, //ENSINO RELIGIOSO
  41, //EDUCAÇÃO FÍSICA
  40, //ARTE (EDUCAÇÃO ARTÍSTICA, TEATRO, DANÇA, MÚSICA, ARTES PLÁSTICAS E OUTRAS)
  14, //EDUCACAO AMBIENTAL
  7,  //TECNICAS AGRICOLAS
  6,  //HISTÓRIA E CULTURA AFRO
];

export const FLAGS_DIARIO = {
  ACP: 'APROVADO PELO CONSELHO PARCIAL',
  ACF: 'APROVADO PELO CONSELHO FINAL',
  AP: 'APROXIMADO AUTOMATICAMENTE'
};

export const MEDIA = 5;

export const TIPOS_DEFICIENCIA = {
  1: "CEGUEIRA",
  2: "BAIXA VISÃO",
  3: "SURDEZ",
  4: "DEFICIÊNCIA AUDITIVA",
  5: "SURDOCEGUEIRA",
  6: "DEFICIÊNCIA FÍSICA",
  7: "DEFICIÊNCIA INTELECTUAL",
  8: "DEFICIÊNCIA MÚLTIPLA",
  10: "SÍNDROME DE ASPERGER",
  11: "SÍNDROME DE RETT",
  12: "TRANSTORNO DESINTEGRATIVO",
  13: "SUPERDOTAÇÃO",
  14: "TRANSTORNO DO ESPECTRO AUTISTA",
  15: "SÍNDROME DE DOWN",
  16: "VISÃO MONOCULAR",
};

/****** CONSTANTES PLANEJAMENTO PEDAGÓGICO (Protocolo 39077/2026) ******/

export const TIPO_MODELO_PLANEJAMENTO = {
  anos_iniciais: "ANOS INICIAIS (1º AO 5º)",
  anos_finais: "ANOS FINAIS (6º AO 9º)",
  pre_escola: "EDUCAÇÃO INFANTIL - PRÉ-ESCOLA",
  creche: "EDUCAÇÃO INFANTIL - CRECHE",
  eja: "EJA",
  aee: "ATENDIMENTO EDUCACIONAL ESPECIALIZADO - AEE",
};

export const STATUS_PLANEJAMENTO = {
  1: "SUBMETIDO",
  2: "LIDO PELO COORDENADOR",
  3: "COM COMENTÁRIOS",
  4: "VALIDADO",
};

// AEE — Funções Cognitivas
export const FUNCOES_COGNITIVAS_AEE = [
  { key: "atencao", label: "Atenção" },
  { key: "memoria", label: "Memória" },
  { key: "percepcao", label: "Percepção" },
  { key: "concentracao", label: "Concentração" },
  { key: "identidade", label: "Identidade" },
  { key: "comunicacao", label: "Comunicação" },
  { key: "linguagem", label: "Linguagem" },
  { key: "grafomotricidade", label: "Grafomotricidade" },
  { key: "raciocinio_logico", label: "Raciocínio lógico" },
  { key: "outros", label: "Outros" },
];

// AEE — Funções Motoras
export const FUNCOES_MOTORAS_AEE = [
  { key: "psicomotricidade", label: "Psicomotricidade" },
  { key: "esquema_corporal", label: "Esquema Corporal" },
  { key: "lateralidade", label: "Lateralidade" },
  { key: "espacialidade", label: "Espacialidade" },
  { key: "outros", label: "Outros" },
];

// AEE — Funções Sociais
export const FUNCOES_SOCIAIS_AEE = [
  { key: "atividade_vida_diaria", label: "Atividade de vida diária" },
  { key: "interacao", label: "Interação" },
  { key: "vivencias", label: "Vivências" },
  { key: "outros", label: "Outros" },
];

// AEE — Funções Emocionais
export const FUNCOES_EMOCIONAIS_AEE = [
  { key: "autoestima", label: "Autoestima" },
  { key: "frustracao_emocoes", label: "Frustração/Emoções" },
  { key: "outros", label: "Outros" },
];

// AEE — Avaliação Processual e Contínua
export const AVALIACAO_PROCESSUAL_AEE = [
  { key: "manter_estrategia", label: "Manter estratégia" },
  { key: "adaptar_estrategia", label: "Adaptar estratégia" },
  { key: "replanejar", label: "Replanejar" },
  { key: "ampliar_desafios", label: "Ampliar desafios" },
  { key: "outros", label: "Outros" },
];

export const PRATICAS_LINGUAGEM = [
  { key: "oralidade", label: "Oralidade" },
  { key: "leitura_escuta_compreensao", label: "Leitura/Escuta/Compreensão" },
  { key: "analise_linguistica_semiotica", label: "Análise Linguística/Semiótica" },
  { key: "escrita", label: "Escrita" },
];

export const UNIDADES_TEMATICAS_MATEMATICA = [
  { key: "numeros", label: "Números" },
  { key: "algebra", label: "Álgebra" },
  { key: "geometria", label: "Geometria" },
  { key: "grandezas_medidas", label: "Grandezas e Medidas" },
  { key: "probabilidade_estatistica", label: "Probabilidade e Estatística" },
];

export const UNIDADES_TEMATICAS_CIENCIAS = [
  { key: "materia_energia", label: "Matéria e Energia" },
  { key: "vida_evolucao", label: "Vida e Evolução" },
  { key: "terra_universo", label: "Terra e Universo" },
];

export const UNIDADES_TEMATICAS_GEOGRAFIA = [
  { key: "sujeito_lugar_mundo", label: "O Sujeito e Seu Lugar no Mundo" },
  { key: "conexoes_escalas", label: "Conexões e Escalas" },
  { key: "mundo_trabalho", label: "Mundo do Trabalho" },
  { key: "formas_representacao", label: "Formas de Representação e Pensamento Espacial" },
  { key: "natureza_ambientes", label: "Natureza, Ambientes e Qualidade de Vida" },
];

export const UNIDADES_TEMATICAS_HISTORIA = [
  { key: "mundo_pessoal_lugar", label: "Mundo Pessoal: Meu Lugar no Mundo" },
  { key: "mundo_pessoal_grupo", label: "Mundo Pessoal: Eu, Meu Grupo Social e Meu Tempo" },
  { key: "registros_historia", label: "Registros da História: Linguagens e Culturas" },
];

export const AVALIACAO_OPCOES_ANOS_INICIAIS = [
  { key: "teste_leitura", label: "Teste de Leitura" },
  { key: "producao_escrita", label: "Produção Escrita" },
  { key: "estudo_dirigido", label: "Estudo Dirigido" },
  { key: "testes_diversificados", label: "Testes Diversificados" },
  { key: "maquetes", label: "Maquetes" },
  { key: "experimentos", label: "Realização de Experimentos" },
  { key: "cartazes", label: "Confecção de Cartazes" },
  { key: "avaliacoes_formativas", label: "Avaliações Formativas" },
  { key: "jogos", label: "Confecção de Jogos" },
  { key: "apresentacoes_seminarios", label: "Apresentações Orais/Seminários" },
  { key: "recuperacao_paralela", label: "Atividades de Recuperação Paralela" },
];

export const CAMPOS_EXPERIENCIA = [
  { key: "eu_outro_nos", label: "O eu, o outro e o nós" },
  { key: "corpo_gestos_movimentos", label: "Corpo, gestos e movimentos" },
  { key: "tracos_sons_cores_formas", label: "Traços, sons, cores e formas" },
  { key: "escuta_fala_pensamento", label: "Escuta, fala, pensamento e imaginação" },
  { key: "espacos_tempos_quantidades", label: "Espaços, tempos, quantidades, relações e transformações" },
];

export const ATIVIDADES_PRIORITARIAS_PRE_ESCOLA = [
  { key: "oralidade", label: "Oralidade" },
  { key: "leitura_escrita", label: "Leitura e Escrita" },
  { key: "psicomotricidade", label: "Psicomotricidade" },
  { key: "letramento_matematico", label: "Letramento Matemático" },
  { key: "brincadeiras", label: "Brincadeiras" },
  { key: "registro", label: "Registro" },
  { key: "musicalizacao", label: "Musicalização" },
  { key: "proleei", label: "Atividades do projeto institucional" },
];

export const ATIVIDADES_PRIORITARIAS_CRECHE = [
  { key: "oralidade", label: "Oralidade" },
  { key: "leitura_escrita", label: "Leitura e Escrita" },
  { key: "psicomotricidade", label: "Psicomotricidade" },
  { key: "letramento_matematico", label: "Letramento Matemático" },
  { key: "brincadeiras", label: "Brincadeiras" },
  { key: "registro", label: "Registro" },
  { key: "musicalizacao", label: "Musicalização" },
  // { key: "coord_motora_ampla", label: "Coord. Motora Ampla" },
  // { key: "coord_motora_fina", label: "Coord. Motora Fina" },
  { key: "set_brasil", label: "Atividades do projeto institucional" },
];

export const ATIVIDADES_PERMANENTES_PRE_ESCOLA = [
  { key: "roda_conversa", label: "Roda de conversa" },
  { key: "nome_proprio", label: "Nome próprio" },
  { key: "musica", label: "Música" },
  { key: "faz_de_conta", label: "Brincadeiras de faz de conta" },
  { key: "brincar_livre", label: "Brincar livre" },
  { key: "alfabeto_movel", label: "Alfabeto móvel" },
  { key: "leitura_escrita", label: "Leitura e escrita" },
  { key: "desenho", label: "Desenho" },
  { key: "producao_oral_escrita", label: "Produção oral ou escrita" },
  { key: "artes", label: "Artes" },
];

export const LETRAMENTO_MATEMATICO_OPCOES = [
  { key: "calendario", label: "Calendário" },
  { key: "contagem_quantificacao", label: "Contagem/quantificação" },
  { key: "desafios", label: "Desafios" },
  { key: "conceitos_basicos", label: "Conceitos básicos" },
  { key: "tracado_numeros", label: "Traçado dos números" },
  { key: "comparacoes", label: "Comparações" },
  { key: "formas_geometricas", label: "Formas geométricas" },
  { key: "medicoes", label: "Medições" },
  { key: "quebra_cabeca", label: "Quebra-cabeça" },
  { key: "quantidades_descontinuas", label: "Quantidades descontínuas" },
  { key: "classificacao", label: "Classificação" },
  { key: "esquema_corporal", label: "Esquema corporal" },
  { key: "seriacao", label: "Seriação" },
  { key: "orientacao_temporal", label: "Orientação temporal" },
  { key: "orientacao_espacial", label: "Orientação espacial" },
  { key: "graficos", label: "Gráficos" },
  { key: "coord_motora_ampla", label: "Coord. motora ampla" },
  { key: "tabelas", label: "Tabelas" },
  { key: "coord_motora_fina", label: "Coord. motora fina" },
  { key: "blocos_logicos", label: "Blocos lógicos" },
];

export const EIXOS_EJA = [
  { key: "identidade_diversidade", label: "Identidade, diversidade e diferença" },
  { key: "cultura_trabalho", label: "Cultura e trabalho" },
  { key: "meio_ambiente", label: "Meio ambiente e ecopedagogia" },
  { key: "direitos_humanos", label: "Direitos humanos e cidadania" },
  { key: "saude_ciencia", label: "Saúde, ciência e tecnologia" },
  { key: "multiculturalismo", label: "Multiculturalismo, memória e planetaridade" },
];

export const MATERIAL_EJA = [
  { key: "livro_didatico", label: "Livro didático" },
  { key: "outros", label: "Outros" },
];

export const ATIVIDADES_ACOLHIMENTO_CRECHE = [
  { key: "brincadeiras_colchonete", label: "Brinquedos no colchonete" },
  { key: "musica_caixinhas_sensoriais", label: "Música ou caixinhas sensoriais" },
  { key: "jogos_encaixe", label: "Jogos de encaixe" },
  { key: "brincadeiras_cantadas", label: "Brincadeiras cantadas" },
  { key: "brincadeiras_ar_livre", label: "Brincadeiras ao ar livre" },
  { key: "outra", label: "Outra(A):" },
];

export const ATIVIDADES_PERMANENTES_CRECHE = [
  { key: "atividades_rodinha", label: "Atividades na rodinha" },
  { key: "conta_historia", label: "Contação de história" },
  { key: "musica", label: "Música" },
  { key: "atividade_sequencia_didatica", label: "Atividade relacionada à sequência ou projeto didático" },
  { key:"registro", label: "Registro"},
  { key: "outra", label: "Outra(A):" },
];

export const ATIVIDADES_ACOLHIMENTO_PRE_ESCOLA = [
  { key: "brinquedo_escolhido_pela_crianca", label: "Brinquedo escolhido pela criança" },
  { key: "jogos_de_mesa", label: "Jogos de mesa" },
  { key: "revistas_jornais_papeis_panfletos_para_recortar", label: "Revistas, jornais, papeis, panfletos para recortar" },
  { key: "blocos_logicos_e_pecas_de_encaixe", label: "Blocos lógicos e peças de  encaixe" },
  { key: "livros_e_gibis", label: "Livros e gibis" },  
];
